<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="RegionAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("regionAccessAdd") }}
                  </h6>
                  <button
                    class="btn btn-light btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="d-flex justify-content-between align-items-baseline mb-2"
                    ></div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("regionCode") }}
                        </label>
                      </div>
                      <div class="col-lg-4">
                        <input
                          type="text"
                          class="form-control"
                          id="region code"
                          :placeholder="$t('regionCode')"
                          v-model="forms.region_code"
                          required
                        />
                        <div v-if="errors.region_code">
                          <div
                            v-for="error in errors.region_code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("descriptionTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="region_description"
                          :placeholder="$t('descriptionTxt')"
                          v-model="forms.region_description"
                          required
                        />
                        <div v-if="errors.region_description">
                          <div
                            v-for="error in errors.region_description"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("countryTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchCountryCode"
                          v-model="country"
                          label="country"
                          return-object
                          @input="contryCodeChange"
                        ></v-select>
                        <div v-if="errors.country">
                          <div
                            v-for="error in errors.country"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("provinceTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="featchProvinceCode"
                          v-model="province"
                          @input="provinceCodeChange"
                          @search="asyncLoadProvinceCode"
                          label="province"
                          return-object
                        ></v-select>
                        <div v-if="errors.province">
                          <div
                            v-for="error in errors.province"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("cityTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          v-model="city"
                          id="city"
                          :placeholder="$t('cityTxt')"
                        />
                        <!-- <v-select
                          :options="featchCityCode"
                          v-model="city"
                          label="city"
                          return-object
                          @input="cityCodeChange"
                        ></v-select> -->
                        <div v-if="errors.city">
                          <div
                            v-for="error in errors.city"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                        <input
                          type="text"
                          class="form-control"
                          id="city_type"
                          :placeholder="$t('cityTypeTxt')"
                          v-model="city_type"
                        />
                        <div v-if="errors.city_type">
                          <div
                            v-for="error in errors.city_type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div> -->
                    </div>

                    <!-- <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("districtTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-4">
                        <v-select
                          :options="featchDistrictCode"
                          v-model="district"
                          label="district"
                          return-object
                          @input="districtCodeChange"
                        ></v-select>
                        <div v-if="errors.district">
                          <div
                            v-for="error in errors.district"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <v-select
                          :options="featchSubDistrictCode"
                          v-model="sub_district"
                          @input="subDistrictCodeChange"
                          label="sub_district"
                          return-object
                        ></v-select>
                        <div v-if="errors.sub_district">
                          <div
                            v-for="error in errors.sub_district"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("postalCodeTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-4">
                        <v-select
                          :options="fetchPostalCode"
                          v-model="postal_code"
                          @search="asyncGeneratePostalCode"
                          label="postal_code"
                          @input="postalCodeChange"
                          return-object
                        ></v-select>

                        <div v-if="errors.postal_code">
                          <div
                            v-for="error in errors.postal_code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Division</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchDivision"
                          v-model="division"
                          @search="asyncDivision"
                          label="code"
                          return-object
                        ></v-select>
                        <div v-if="errors.division">
                          <div
                            v-for="error in errors.division"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="file_upload"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >File Upload Cross Reference</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="file_upload"
                          :placeholder="'File Upload'"
                          v-model="forms.file_upload"
                          required
                        />
                        <div v-if="errors.file_upload">
                          <div
                            v-for="error in errors.file_upload"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-12" style="padding-left: 45px">
                        <div class="row mb-3">Region Available In :</div>
                        <div class="row">
                          <div class="col-sm-3">
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="execution_status"
                                true-value="yes"
                                false-value="no"
                                class="form-check-input"
                                id="execution_status"
                              />
                              <label
                                class="form-check-label"
                                for="execution_status"
                              >
                                Execution Status
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="shipment_status"
                                class="form-check-input"
                                id="shipment_status"
                                true-value="yes"
                                false-value="no"
                              />
                              <label
                                class="form-check-label"
                                for="shipment_status"
                              >
                                Shipment Status
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="optimizer"
                                class="form-check-input"
                                id="optimizer"
                                true-value="yes"
                                false-value="no"
                              />
                              <label class="form-check-label" for="optimizer">
                                Optimizer
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="payable_rate_estimation"
                                class="form-check-input"
                                id="payable_rate_estimation"
                                true-value="yes"
                                false-value="no"
                              />
                              <label
                                class="form-check-label"
                                for="payable_rate_estimation"
                              >
                                Payable Rate Estimation
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="freight_builder"
                                true-value="yes"
                                false-value="no"
                                class="form-check-input"
                                id="freight_builder"
                              />
                              <label
                                class="form-check-label"
                                for="freight_builder"
                              >
                                Freight Builder
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="rate_management"
                                class="form-check-input"
                                id="rate_management"
                                true-value="yes"
                                false-value="no"
                              />
                              <label
                                class="form-check-label"
                                for="rate_management"
                              >
                                Rate Management
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="pooling"
                                class="form-check-input"
                                id="pooling"
                                true-value="yes"
                                false-value="no"
                              />
                              <label class="form-check-label" for="pooling">
                                Pooling
                              </label>
                            </div>
                            <div class="form-check mb-2">
                              <input
                                type="checkbox"
                                v-model="waypoints"
                                class="form-check-input"
                                id="waypoints"
                                true-value="yes"
                                false-value="no"
                              />
                              <label class="form-check-label" for="waypoints">
                                Waypoints
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from "@/middleware/mixinAddress.js";

export default {
  name: "RegionAdd",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      regionCode: "",
      fetchPostalCode: [],
      fetchCountryCode: [],
      featchProvinceCode: [],
      featchCityCode: [],
      featchDistrictCode: [],
      featchSubDistrictCode: [],
      forms: { name: "", usernmae: "" },
      postal_code: [],
      country: [],
      province: [],
      city: [],
      district: [],
      sub_district: [],
      city_type: "",
      fetchDivision: [],
      division: "",

      execution_status: "yes",
      shipment_status: "yes",
      optimizer: "yes",
      freight_builder: "yes",
      rate_management: "yes",
      pooling: "yes",
      payable_rate_estimation: "yes",
      waypoints: "yes",
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.region_code = "";
      this.forms.region_description = "";
      this.forms.country = "";
      this.forms.province = "";
      this.forms.city = "";
      this.forms.city_type = "";
      this.forms.district = "";
      this.forms.sub_district = "";
      this.forms.postal_code = "";
      this.country = [];
      this.province = [];
      this.city = "";
      this.district = [];
      this.sub_district = [];
      this.postal_code = [];
      this.city_type = "";
      this.division = "";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "RegionController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/region";
    },

    submitData() {
      this.fade(true);
      this.forms.country = this.country.country;
      this.forms.province = this.province.province;
      this.forms.city = this.city;
      // this.forms.city_type = this.city_type;
      // this.forms.district = this.district;
      // this.forms.sub_district = this.sub_district;
      // this.forms.postal_code = this.postal_code;
      this.forms.status = "ENABLED";
      this.forms.division = this.division;
      this.forms.execution_status = this.execution_status;
      this.forms.shipment_status = this.shipment_status;
      this.forms.optimizer = this.optimizer;
      this.forms.freight_builder = this.freight_builder;
      this.forms.rate_management = this.rate_management;
      this.forms.pooling = this.pooling;
      this.forms.payable_rate_estimation = this.payable_rate_estimation;
      this.forms.waypoints = this.waypoints;

      // this.forms.postal_code=this.forms.postalCode.postal_code;
      //this.forms;
      // console.log(this.forms);
      const baseURI = this.$settings.endPoint + "region/create";
      this.$http
        .post(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            //console.log(response.data.datas.user_id);
            var params = this.$onRandom(response.data.datas.region_id);
            window.location.href =
              "/region/detail/" + params + "?status=200&msg=Successfully";
            //this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },
    loadDivision() {
      const baseURI =
        this.$settings.endPointCt + `master-lookup?unique_id=rgdiv`;
      this.fade(true);
      return this.$http.get(baseURI).then((response) => {
        this.fetchDivision = response.data.datas;
        this.fade(false);
      });
    },
    asyncDivision(ev) {
      const baseURI =
        this.$settings.endPoint + `master-lookup?unique_id=rgdiv&search=${ev}`;
      this.fetchDivision = [];
      return this.$http.get(baseURI).then((response) => {
        this.fetchDivision = response.data.datas.data;
      });
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadPostalCode();
    this.loadCountryCode();
    this.loadDivision();
  },
};
</script>
<style scoped></style>
